import { monitorLayout, rotatePoint } from './monitor_layout.js';

export const MonitorMethods = {
  _monitorLayout() {
    return monitorLayout(
      {
        width: this.positionScreenWidthValue || 1920,
        height: this.positionScreenHeightValue || 1080,
        gameWidth: this.positionWindowWidthValue || 1920,
        gameHeight: this.positionWindowHeightValue || 1080,
        charactersWidth: this.positionCharactersWidthValue,
        charactersHeight: this.positionCharactersHeightValue,
        characters: this.positionCharactersVisibleValue,
        game: this.positionGameVisibleValue,
        side: this.characterPlacementValue,
        rotation: this.gameViewRotationValue,
        zoom: this._monitorZoom || 1
      },
      { width: this.viewportTarget.clientWidth, height: this.viewportTarget.clientHeight }
    );
  },

  _layoutMonitor() {
    if (!this.hasPositionMonitorTarget || !this.hasViewportTarget) return;
    const layout = this._monitorLayout();
    const bounds = (element, rect) => {
      Object.assign(element.style, {
        left: `${rect.x}px`,
        top: `${rect.y}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`
      });
    };
    bounds(this.monitorBezelTarget, layout);
    bounds(this.positionViewportTarget, layout.map);
    bounds(this.positionCharactersViewportTarget, layout.roster);
    this.positionViewportTarget.hidden = !layout.game;
    this.monitorMissingTarget.hidden = layout.game;
    this.positionMonitorTarget.dataset.game = String(layout.game);
    this.positionCharactersViewportTarget.hidden = !this.positionCharactersVisibleValue;
    this.positionCharactersViewportTarget.dataset.side = layout.side;
    this.monitorRotationTarget.textContent = `${layout.degrees}°`;
    for (const label of this.positionViewportLabelTargets)
      label.textContent = `${this.positionDisplayLabelValue} · ${this.positionScreenWidthValue} × ${this.positionScreenHeightValue}`;
    this.positionMonitorTarget.setAttribute(
      'aria-label',
      `${this.positionDisplayLabelValue}. ${this.positionCharactersVisibleValue ? 'Character list at ' + layout.side : 'No character list'}. ${layout.game ? 'Map rotation ' + layout.degrees + ' degrees' : 'No game view'}.`
    );
    return layout;
  },

  _monitorTransform() {
    const layout = this._layoutMonitor();
    const scale = layout.base * (1 + this.positionZoomValue / 100);
    const offset = rotatePoint(
      {
        x: (this.positionPosXValue / 100 - 0.5) * this._imgWidth * scale,
        y: (this.positionPosYValue / 100 - 0.5) * this._imgHeight * scale
      },
      layout.degrees
    );
    return {
      width: this.viewportTarget.clientWidth,
      height: this.viewportTarget.clientHeight,
      scale,
      x: layout.center.x + offset.x,
      y: layout.center.y + offset.y,
      rotation: layout.degrees
    };
  },

  _monitorDragDelta(dx, dy) {
    return rotatePoint({ x: dx, y: dy }, -this._monitorLayout().degrees);
  },

  _applyMonitorPinch(next) {
    const layout = this._monitorLayout();
    const local = rotatePoint({ x: next.x - layout.center.x, y: next.y - layout.center.y }, -layout.degrees);
    this.positionZoomValue = (next.scale / layout.base - 1) * 100;
    this.positionPosXValue = (local.x / (this._imgWidth * next.scale) + 0.5) * 100;
    this.positionPosYValue = (local.y / (this._imgHeight * next.scale) + 0.5) * 100;
    this._applyPositionManagerTransform();
  }
};
